import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import PoundCircleFilledSvg from "@ant-design/icons-svg/es/asn/PoundCircleFilled";
import AntdIcon from "../components/AntdIcon";
var PoundCircleFilled = function PoundCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PoundCircleFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  PoundCircleFilled.displayName = 'PoundCircleFilled';
}
export default /*#__PURE__*/React.forwardRef(PoundCircleFilled);